import { useEffect, useState } from 'react';
import MaterialTable from 'material-table';
import { getCompaniesApi, deleteCompanyApi } from '../../api/companies';
import common from '../../strings/common.json';
import Company from '../Dialogs/Company';
import LoadIndicator from '../../components/LoadIndicator';

const Companies = ({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (value: any) => void;
}): JSX.Element => {
  const [companies, setCompanies] = useState([]);

  const [selectedCompany, setSelectedCompany] = useState();
  const [refreshResults, setRefreshResults] = useState(true);
  const [loading, setLoading] = useState(false);

  const actions = [
    {
      icon: 'edit',
      tooltip: common.companyDialog.edit,
      // @ts-ignore
      onClick: (e: any, rowData: any) => selectCompany(e, rowData),
    },
    {
      icon: 'delete',
      tooltip: common.companyDialog.delete,
      // @ts-ignore
      onClick: (e: any, rowData: any) => deleteSelectedCompany(e, rowData),
    },
  ];

  const selectCompany = (e: any, rowData: any) => {
    setSelectedCompany(rowData);
    setOpen(true);
  };

  useEffect(() => {
    const get = async () => {
      setLoading(true);
      const response = await getCompaniesApi();
      setCompanies(response);
      setLoading(false);
    };
    if (refreshResults) {
      get();
      setRefreshResults(false);
    }
  }, [refreshResults]);

  const deleteSelectedCompany = async (e: any, rowData: any) => {
    if (window.confirm(common.companyDialog.confirmDelete)) {
      const response = await deleteCompanyApi(rowData.id);
      if (response !== 200) {
        window.alert(common.machineDialog.errorDelete);
        return;
      }
      setRefreshResults(true);
    }
  };

  if (loading) {
    return <LoadIndicator />;
  }
  return (
    <>
      <MaterialTable
        title=""
        localization={{
          header: {
            actions: '',
          },
        }}
        columns={[
          {
            field: 'name',
          },
        ]}
        data={companies}
        actions={actions}
        options={{
          actionsColumnIndex: -1,
          sorting: false,
          draggable: false,
          toolbar: false,
          header: false,
          paging: false,
        }}
      />
      <Company
        open={open}
        setOpen={setOpen}
        selectedCompany={selectedCompany}
        refreshPage={() => setRefreshResults(true)}
        setSelectedCompany={setSelectedCompany}
      />
    </>
  );
};

export default Companies;
